export default __webpack_public_path__ + "static/media/wallet.ca95e6e3.webp";